import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Admin-only reversible "Remove from workspace" / "Restore" (server enforces platform_admin).
export const RemoveHouseholdButton = ({ hid, name, archived, onDone }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (user?.role !== "platform_admin") return null;

  const act = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/test-data/households/${hid}/${archived ? "restore" : "remove"}`, archived ? undefined : { reason: "Removed from workspace by admin" });
      toast.success(archived ? "Household restored to the workspace." : "Household removed from the workspace.");
      setOpen(false); onDone && onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Action failed."); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button size="sm" variant="outline" className="rounded-full px-4" onClick={() => (archived ? act() : setOpen(true))} disabled={busy}
        data-testid={archived ? "household-restore-btn" : "household-remove-btn"}>
        {archived ? "Restore to workspace" : "Remove from workspace"}
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="household-remove-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Remove “{name}” from the workspace?</AlertDialogTitle>
            <AlertDialogDescription>
              It will be hidden from active household lists, queues and counts. Nothing is deleted: its history,
              assignment, recordings and account stay intact, and an admin can restore it from “Test &amp; archived”.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="household-remove-cancel">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={act} disabled={busy} data-testid="household-remove-confirm">Remove from workspace</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
